import { Typography } from "@material-tailwind/react";
import SideBar from "../../components/sidebar.tsx/SideBar";
import { useState } from "react";
import TransactionTable from "./components/TransactionTable";

function Transactions() {
  const [activeTab, setActiveTab] = useState("Credit");
  const tabs = ["Credit", "Debit"];
  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <div className="lg:flex">
      <SideBar />
      <div className="lg:ml-14 lg:m-14 p-6 w-full text-center">
        <div className="w-full">
          <Typography placeholder={undefined} className="text-3xl font-semibold">
            Transactions
          </Typography>
          <Typography placeholder={undefined} className="my-4">
            View all transactions across board
          </Typography>
          <div className=" ">
            <nav
              className="flex space-x-2 py-2 justify-center"
              aria-label="Tabs"
              role="tablist"
            >
              {tabs.map((tab) => (
                <button
                  key={tab}
                  type="button"
                  className={`py-2 px-1 inline-flex items-center gap-x-2 whitespace-nowrap text-gray-500  focus:outline-none disabled:opacity-50 disabled:pointer-events-none ${
                    activeTab === tab
                      ? "text-red-500 border-b border-red-600"
                      : ""
                  }`}
                  id={`tabs-with-underline-item-${tab}`}
                  data-hs-tab={`#tabs-with-underline-${tab}`}
                  aria-controls={`tabs-with-underline-${tab}`}
                  role="tab"
                  onClick={() => handleTabClick(tab)}
                >
                  {tab === "Credit" ? "Credit" : "Debit"}
                </button>
              ))}
            </nav>
            <div className="mt-3 ">
              {tabs.map((tab) => (
                <div
                  key={tab}
                  id={`tabs-with-underline-${tab}`}
                  role="tabpanel"
                  aria-labelledby={`tabs-with-underline-item-${tab}`}
                  className={`${activeTab === tab ? "" : "hidden"}`}
                >
                  <div className="font-semibold text-gray-800 ">
                    {tab === "Credit" ? (
                      <TransactionTable transactionType="Credit" />
                    ) : (
                      <TransactionTable transactionType="Debit" />
                    )}{" "}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Transactions;
